<template>
  <div>
    <template v-if="isEdit">
      <template>
        <div class="form-control" style="display: flow-root">
          <toggle-button
            v-model="value.status"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
          {{ $t('Turn on follow up feature') }}
          <div class="mt-2">{{ $t('Schedule follow up time (Hours:Minutes)') }}</div>
          <time-picker
            v-model="value.delay_time"
            class="mt-1"
            full-width
            :min-range="
              !value.delay_time ||
              (value.delay_time && (value.delay_time.HH === '' || value.delay_time.HH === '00'))
                ? [[5, 55]]
                : null
            "
            :minute-interval="5"
            hide-disabled-minutes
          ></time-picker>
        </div>
      </template>
      <v-layout>
        <v-flex
          v-if="value.showMultipleChannel"
          class="channel"
          shrink
          style="border-right: 1px solid #eee"
        >
          <template v-for="social in conversationSocialChannelOptions">
            <div
              :key="`tab-${social.value}`"
              :class="{
                'primary white--text': tab == social.value
              }"
              class="py-1 pl-2 pr-2"
              style="
                border: 1px solid #eee;
                border-width: 1px 0px 1px 1px;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                cursor: pointer;
              "
              @click="tab = social.value"
            >
              <span :class="social.icon"></span>
            </div>
          </template>
        </v-flex>
        <v-flex :key="timestamp" style="overflow: auto">
          <template v-if="!value.showMultipleChannel">
            <intent-group
              v-model="value.messages"
              :show-multiple-channel="value.showMultipleChannel"
              :available-bubbles="['text', 'image', 'button']"
              :follow-up="true"
              @changeSetting="changeSetting"
            ></intent-group>
          </template>
          <template v-else>
            <template v-for="social in conversationSocialChannelOptions">
              <div v-show="social.value == tab" :key="`message-${social.value}`">
                <keep-alive>
                  <intent-group
                    :key="`${social.value}_message`"
                    v-model="value.multiMessages[`${social.value}_messages`]"
                    :show-multiple-channel="value.showMultipleChannel"
                    :channel="tab"
                    :available-bubbles="['text', 'image', 'button']"
                    :follow-up="true"
                    @changeSetting="changeSetting"
                  ></intent-group>
                </keep-alive>
              </div>
            </template>
          </template>

          <div>
            <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>
            <div class="mb-3"></div>

            <template v-if="!value.showMultipleChannel">
              <div
                class="form-control"
                :class="{ 'has-error': errorTag['quick_reply'].length > 0 }"
              >
                <tags
                  v-model="value.quick_reply"
                  :tags="value.quick_reply"
                  style="margin-bottom: 5px"
                  :btn-text="$t('Add choice')"
                  @tags-changed="addReplies('follow_up_cart_quick_reply', $event)"
                  @before-adding-tag="checkQuickReply('follow_up_cart_quick_reply', $event)"
                ></tags>
              </div>
            </template>
            <template v-else>
              <div
                class="form-control"
                :class="{ 'has-error': errorTag[`${tab}_quick_reply`].length > 0 }"
              >
                <tags
                  v-model="value.multiQuickReply[`${tab}_quick_reply`]"
                  :tags="value.multiQuickReply[`${tab}_quick_reply`]"
                  style="margin-bottom: 5px"
                  :btn-text="$t('Add choice')"
                  @tags-changed="addReplies(tab, $event)"
                  @before-adding-tag="checkQuickReply(`${tab}`, $event)"
                ></tags>
              </div>
            </template>
            <div class="form-control has-error">
              <template v-for="(error, errorKey) in errorTag">
                <span v-if="error.length > 0" :key="errorKey" class="text-error">
                  <template v-if="error.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="error.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="error.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <div class="mt-3 mb-3">
        <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
          <em class="far fa-eye" />
          {{ $t('preview') }}
        </a>
        <preview-message
          v-if="showPreview"
          :messages="messagesPreview"
          :choice="quickReplyPreview"
          :questions="[]"
          @close="showPreview = false"
        ></preview-message>
      </div>
    </template>
    <template v-else>
      <p>
        {{ $t('status') }}
        <span v-if="value.status"> <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
        ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
      </p>
      <p v-if="value && value.delay_time">
        <span
          >{{ value.delay_time ? value.delay_time.HH : '00' }}

          {{ $t('hour') }}</span
        >
        <span>{{ value.delay_time ? value.delay_time.mm : '00' }} {{ $t('minute') }}</span>
      </p>
      <v-layout>
        <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
          <p>{{ $t('Chatbot answers') }}</p>
          <template v-if="value.type == 'json'">
            <template v-if="!value.showMultipleChannel">
              <template v-if="value.messages && value.messages[0].length > 0">
                <message-viewer v-model="value.messages" :channel="tab"></message-viewer>
              </template>
              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
            </template>
            <template v-else>
              <v-layout>
                <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                  <template v-for="social in conversationSocialChannelOptions">
                    <div
                      :key="`tab-${social.value}`"
                      :class="{
                        'primary white--text': tab == social.value
                      }"
                      class="py-1 pl-2 pr-2"
                      style="
                        border: 1px solid #eee;
                        border-width: 1px 0px 1px 1px;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                        cursor: pointer;
                      "
                      @click="tab = social.value"
                    >
                      <span :class="social.icon"></span>
                    </div>
                  </template>
                </v-flex>
                <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                  <template v-for="social in conversationSocialChannelOptions">
                    <div v-show="tab == social.value" :key="`message-${social.value}`">
                      <template
                        v-if="
                          value.multiMessages[`${social.value}_messages`] &&
                          value.multiMessages[`${social.value}_messages`][0].length > 0
                        "
                      >
                        <message-viewer
                          v-model="value.multiMessages[`${social.value}_messages`]"
                          :channel="tab"
                        ></message-viewer>
                      </template>
                      <p v-else class="primary-color pl-1">
                        {{ $t('No reply') }}
                      </p>
                    </div>
                  </template>
                </v-flex>
              </v-layout>
            </template>
          </template>
          <template>
            <div>
              <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
              <div class="quickreply">
                <template v-if="quick_reply.length > 0">
                  <ul class="tags">
                    <li v-for="(reply, index) in quick_reply" :key="'replies' + index" class="tag">
                      {{ reply }}
                    </li>
                  </ul>
                </template>
                <template v-else>-</template>
              </div>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import MessageViewer from '@/components/elements/MessageViewer'
import IntentGroup from '@/components/view/intent/IntentGroup'
import PreviewMessage from '@/components/elements/PreviewMessage'
import Tags from '@/components/elements/Tags'
import { ToggleButton } from 'vue-js-toggle-button'
import TimePicker from '@/components/elements/TimePicker.vue'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
export default {
  components: {
    MessageViewer,
    IntentGroup,
    PreviewMessage,
    Tags,
    TimePicker,
    ToggleButton
  },
  props: {
    value: {},
    isEdit: {}
  },
  data() {
    return {
      followup: {
        status: false,
        delay_time: '',
        type: 'json'
      },
      replies: [],
      showPreview: false,
      tab: 'all',
      messages: [],
      errorTag: {
        quick_reply: [],
        ...this.conversationSocialChannelOptions.reduce((prev, social) => {
          prev[`${social.value}_quick_reply`] = []
          return prev
        }, {})
      },
      timestamp: moment().format('x')
    }
  },
  computed: {
    messagesPreview: function () {
      if (this.value.tab == 'all') {
        return this.value.messages || [[]]
      } else {
        return this.value.multiMessages[`${this.value.tab}_messages`] || [[]]
      }
    },
    quickReplyPreview: function () {
      if (this.value.tab == 'all') {
        return this.value.quick_reply || []
      } else {
        return this.value.multiQuickReply[`${this.value.tab}_quick_reply`] || []
      }
    },
    quick_reply: function () {
      if (this.value.tab == 'all') {
        return this.value.quick_reply ? this.value.quick_reply.map((el) => el.text) : []
      } else {
        return this.value.multiQuickReply[`${this.value.tab}_quick_reply`]
          ? this.value.multiQuickReply[`${this.value.tab}_quick_reply`].map((el) => el.text)
          : []
      }
    }
  },
  methods: {
    async changeSetting(payload) {
      if (Object.prototype.hasOwnProperty.call(payload, 'showMultipleChannel')) {
        if (
          this.value.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages = cloneDeep(this.value.messages)
          const multi_fb_messages = fb_messages.map((el) => {
            return el.filter((sel) => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          this.$set(this.value.multiMessages, 'fb_messages', multi_fb_messages)
          this.$set(this.value.multiMessages, 'line_messages', cloneDeep(this.value.messages))
          this.$set(
            this.value.multiMessages,
            'ig_messages',
            this.ig_messages
              ? this.ig_messages.map((el) => {
                  return el.filter((sel) => {
                    return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                  }, [])
                }, [])
              : cloneDeep(this.value.messages) || [[]]
          )

          this.$set(this.value.multiQuickReply, 'fb_quick_reply', this.value.quick_reply)
          this.$set(this.value.multiQuickReply, 'line_quick_reply', this.value.quick_reply)
          this.$set(this.value.multiQuickReply, 'ig_quick_reply', this.value.quick_reply)
        }
        this.$set(this.value, 'showMultipleChannel', payload.showMultipleChannel)

        if (this.value.showMultipleChannel) this.tab = 'fb'
        else this.tab = 'all'
      }
    },
    checkQuickReply(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error('overmaxlength:20')
      } else if (
        obj.type == 'add' &&
        ((type == 'replies' && this.value.quick_reply.length >= 10) ||
          (this.conversationSocialChannelOptions.map((el) => el.value).includes(type) &&
            this.value.multiQuickReply[`${type}_quick_reply`].length >= 10))
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error('overtagmax:10')
      } else if (obj.tag.isDuplicate) {
        this.errorTag[type].push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    addReplies: function (type, newTags) {
      if (this.conversationSocialChannelOptions.map((el) => el.value).includes(type)) {
        this.$set(this.value.multiQuickReply, `${type}_quick_reply`, newTags)
      } else {
        this.$set(this.value, 'quick_reply', newTags)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PaymentFollowupMessageAfterSummary.vue